import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { BugPriority, StatoAnomalia } from 'src/app/model/customer';
import { ProductDto } from 'src/app/model/ProductDto';
import { ProjectBugReleases } from 'src/app/model/ProjectBugReleases';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { PaiIncident, PaiIncidentRow, RowType } from 'src/app/model/PaiIncident';
import { ArchiviedDocumentInfo } from 'src/app/model/ArchiviedDocumentInfo';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { ReportsService } from 'src/app/core/services/reports.service';

@Component({
  selector: 'ms-incident-details',
  templateUrl: './incident-details.component.html',
  styleUrls: ['./incident-details.component.scss']
})

export class IncidentDetailsComponent implements OnInit {
  incident: PaiIncident;
  productDto: ProductDto;
  displayedColumns: string[] = ['gravityNumber', 'gravityDescription'];
  localizedFields: Map<string, string> = new Map<string, string>();

  constructor(
    private router: Router,
    private navigateService: NavigateService,
    public cmsService: CmsService,
    public workFlow: WorkFlowService,
    public productDownloadService: ProductDownloadService,
    private reportsService: ReportsService
  ) { }

  async ngOnInit(){
    this.localizedFields = this.reportsService.getLocalizedFields(this.workFlow.getLanguageForCms());

    if(!this.navigateService.getLocalStorageData<ProjectBugReleases>('incident') || !this.navigateService.getLocalStorageData<ProductDto>('productDto'))
      this.router.navigate(['/technical-support/incidents-finder']);

    this.incident = this.navigateService.getLocalStorageData<PaiIncident>('incident');
    this.productDto = this.navigateService.getLocalStorageData<ProductDto>('productDto');
  }

  getDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString()
  }

  getRowType(incidentRow: PaiIncidentRow){
    if(incidentRow.RowType == RowType['Domanda']) return 'ANSWER'
    else if(incidentRow.RowType == RowType['Risposta']) return 'RESPONSE'
    else return ''
  }

  getOrderedInquiryRows(incident: PaiIncident){
    return incident.InquiryRows.sort((a, b) => { return new Date(a.TBCreated).getTime() - new Date(b.TBCreated).getTime() })
  }

  public downloadArchiviedDocument(attachmentID: number, name: string) {
    let archiviedDocument: ArchiviedDocumentInfo = new ArchiviedDocumentInfo(attachmentID, name);
    this.productDownloadService.downloadArchiviedDocument(archiviedDocument).subscribe(
      data => {
        if(data['ok'] == false){
          alert("Error")
          return;
        }
        switch (data.type) {
          case HttpEventType.DownloadProgress:
            break;
          case HttpEventType.Response:
            this.downloadFile(data, archiviedDocument);
            break;
        }
      }
    );
  }

  downloadFile(data: HttpResponse<Blob>, archiviedDocument: ArchiviedDocumentInfo){
    const downloadedFile = new Blob([data.body], { type: data.body.type });
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = archiviedDocument.Name;
    a.href = URL.createObjectURL(downloadedFile);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
  }
}
